import {IOccupationalStatusProps} from "@my-pages/features/employment/types";
import { formatDate } from '@shared/utils/dateUtils';

const OccupationStatus = ({occupationStatus}: IOccupationalStatusProps) => {
    return (<>
            <h4 className="highlight-mask">{occupationStatus.name}</h4>
            <div className="ft-table ft-flush table-mark-empty mb-0 font-size-sm">
                {occupationStatus.startDate &&
                    <div className="ft-tr">
                        <div className="ft-th">Start</div>
                        <div className="ft-td">{formatDate(occupationStatus.startDate)}</div>

                    </div>
                }
                {occupationStatus.endDate &&
                    <div className="ft-tr">
                        <div className="ft-th">Slut</div>
                        <div className="ft-td">{formatDate(occupationStatus.endDate)}</div>
                    </div>
                }
            </div>
        </>
    )
}

export default OccupationStatus;